import React, { Component } from 'react';
import PropTypes from 'prop-types';
import TextField from '@material-ui/core/TextField';
import { DataTypeProvider, } from '@devexpress/dx-react-grid'

import moment from 'moment';

export default class DobTypeProvider extends Component {
  render() {
    return(
      <DataTypeProvider
        for={this.props.for}
        formatterComponent={({ value }) => value ? (moment(value.toDate()).format('ll') + " (" + moment().diff(moment(value.toDate()), 'years') + ")") : ''}
        editorComponent={({ column, row, value, onValueChange }) => {
          return (row) ? (
            <TextField
              style={{ margin: 8 }}
              fullWidth
              type="date"
              defaultValue={ value ? moment(value.toDate()).format('YYYY-MM-DD') : ''}
              onChange={event => onValueChange(event.target.value ? moment(event.target.value, 'YYYY-MM-DD') : null) } />
          ) : (<div />);
        }}
      />
    );
  }
}

DobTypeProvider.propTypes = {
  for: PropTypes.array.isRequired,
}
